// extracted by mini-css-extract-plugin
module.exports = {"MenuSelectionHolder":"MenuSelection_MenuSelectionHolder__sT8e6","ImageHolder":"MenuSelection_ImageHolder__3X6J3"};